import ExporCenterCenter from './ExporCenterDialog.vue'
import Vue from 'vue'

ExporCenterCenter.newInstance = (props = {}) => {
  const Instance = new Vue({
    data: props,
    render(h) {
      return h(ExporCenterCenter, {
        props
      })
    }
  })
  const component = Instance.$mount()
  document.body.appendChild(component.$el)
  const dialog = Instance.$children[0]

  return {
    open: dialog.open
  }
}

let dialogInstance

function getDialogInstance () {
  dialogInstance = dialogInstance || ExporCenterCenter.newInstance();
  return dialogInstance;
}

export default getDialogInstance
